<script>
    import { createEventDispatcher } from 'svelte'
    import IconifyIcon from '@iconify/svelte'
    import left from '@iconify/icons-fa-solid/chevron-left'
    import right from '@iconify/icons-fa-solid/chevron-right'

    export let currentPage = 0
    export let totalCount = null
    export let totalPages = null
    export let perPage = null
    export let limitItems = 5
    export let disabled = false

    let _totalPages
    $: if (totalCount == null || perPage == null || perPage <= 0) {
        _totalPages = totalPages
    } else {
        _totalPages = totalCount > perPage
            ? Math.ceil(totalCount / perPage)
            : 1
    }

    let length
    let startIndex
    $: length = Math.min(3, limitItems - 2, _totalPages)
    $: startIndex = Math.min(_totalPages - length, Math.max(0, currentPage - Math.floor(length / 2)))

    const dispatch = createEventDispatcher()

    function changePage(page) {
        if (page !== currentPage) {
            currentPage = page
            dispatch('change', page)
        }
    }

    function getPage(index) {
        return startIndex + index
    }
</script>

{#if _totalPages > 1}
    <nav class:disabled={disabled}>
        <ul class="pagination">
            <li class="page-item mobile-only arrow {currentPage === 0 ? 'disabled' : ''}">
                <a href="javascript:;" class="page-link paginate-arrow paginate-double-arrow" on:click="{() => changePage(0)}">
                    <IconifyIcon icon={left}/>
                    <IconifyIcon icon={left}/>
                </a>
            </li>
            <li class="page-item mobile-visible arrow {currentPage === 0 ? 'disabled' : ''}">
                <a href="javascript:;" class="page-link paginate-arrow" on:click="{() => changePage(currentPage - 1)}">
                    <IconifyIcon icon={left}/>
                </a>
            </li>
            {#if startIndex > 1}
                <li class='page-item'>
                    <a href="javascript:;" class="page-link" on:click="{() => changePage(0)}">1</a>
                </li>
            {/if}
            {#if startIndex > 1}
                <li class='page-item disabled dots'>
                    <span class="page-link">...</span>
                </li>
            {/if}
            {#each {length} as _, index}
                <li class='page-item {startIndex + index === currentPage ? "active disabled": ""}'>
                    <a href="javascript:;" class="page-link" on:click="{() => changePage(startIndex + index)}">{startIndex + index + 1}</a>
                </li>
            {/each}
            {#if startIndex + length < _totalPages - 1}
                <li class='page-item disabled dots'>
                    <span class="page-link">...</span>
                </li>
            {/if}
            {#if startIndex + length < _totalPages}
                <li class='page-item'>
                    <a href="javascript:;" class="page-link" on:click="{() => changePage(_totalPages - 1)}">{_totalPages}</a>
                </li>
            {/if}
            <li class="page-item mobile-visible arrow {currentPage === _totalPages - 1 ? 'disabled' : ''}">
                <a href="javascript:;" class="page-link paginate-arrow" on:click="{() => changePage(currentPage + 1)}">
                    <IconifyIcon icon={right}/>
                </a>
            </li>
            <li class="page-item mobile-only arrow {currentPage === _totalPages - 1 ? 'disabled' : ''}">
                <a href="javascript:;" class="page-link paginate-arrow paginate-double-arrow" on:click="{() => changePage(_totalPages - 1)}">
                    <IconifyIcon icon={right}/>
                    <IconifyIcon icon={right}/>
                </a>
            </li>
        </ul>
    </nav>
{/if}

<style>
    .pagination {
        display: flex;
        margin: 30px 0;
        padding-left: 0;
        list-style: none;
        user-select: none;
    }

    .disabled {
        pointer-events: none;
    }

    .page-link {
        position: relative;
        display: block;
        text-decoration: none;
        padding: 4px 7px;
        line-height: normal;
        margin: 0 5px;
        border: 1px solid #CAD5E0;
        border-radius: 5px;
        font-weight: 500;
        color: #CAD5E0;
        background: none;
        min-width: 30px;
        text-align: center;
        font-size: 16px;
        box-shadow: none;
        cursor: pointer;
        transition: .25s;
    }

    .page-link:hover {
        background: #32373d;
    }

    .page-item.active .page-link {
        background: #FF5D1C;
        border-color: #FF5D1C;
        color: white;
    }

    .dots .page-link {
        border-color: transparent;
        padding: 4px 0;
        min-width: initial;
    }

    .mobile-only {
        display: none;
    }

    nav.disabled {
        opacity: 0.8;
    }

    .arrow.disabled a.page-link {
        color: #848488;
        border-color: #848488;
    }

    .paginate-arrow {
        padding: 5px;
        line-height: 16px;
        height: 30px;
        font-size: 17px;
    }

    .paginate-double-arrow :global(svg:last-child) {
        margin-left: -10px;
    }

    @media (max-width: 768px) {
        .pagination {
            justify-content: center;
        }

        .page-item {
            display: none;
        }

        .mobile-only,
        .mobile-visible,
        .active {
            display: block;
        }
    }
</style>
